module.exports = __webpack_public_path__ + "img/ep-logo-distort.fc43f896.png";